import { EnvironmentConfig } from './environment-config.model';

export interface IEnvironmentService {
  getEnvironmentConfig(): EnvironmentConfig;
}
